import React, { useState } from 'react';
import FormManager from '../../../Components/FormManager';
import InputManager from '../../../Components/InputManager';
import { validateEmail, validateMobile } from '../../../helpers/helper';
import { withTranslation } from 'react-i18next';
import './logicPro.css';
import Button from '../../../Components/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestCallback } from '../../../actions/summerInternships';
import Alert from '../../../Components/Alert';

const RequestCallbackForm = ({ t, requestCallback }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isAlertActive, setIsAlertActive] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const validateName = val => val.trim().length < 3;
  const validatePhone = val => !validateMobile(val.trim());
  const validateEmailId = val => !validateEmail(val.trim());

  const toggleLoading = () => {
    setLoading(prev => !prev);
  };

  const setSuccess = status => {
    setIsAlertActive(true);
    setIsSuccess(status);
  };

  const onSubmit = async (data, resetForm) => {
    Object.assign(data, {
      origin: 'lucknow_internship'
    });
    try {
      toggleLoading();
      await requestCallback(data);
      toggleLoading();
      setSuccess(true);
      resetForm();
    } catch (err) {
      toggleLoading();
      setSuccess(false);
    }
  };

  return (
    <div className="logicpro-request-callback-container">
      <h1
        style={{ fontSize: '1.5em', marginBottom: 30 }}
        className="request-callback-text">
        <span className="request-callback-text">Request for Syllabus</span>
      </h1>

      <FormManager
        className="logicpro-request-callback-form"
        onSubmit={onSubmit}>
        <InputManager
          id="name"
          placeholder={t('inputName')}
          className="logicpro-contact-form-field"
          validate={validateName}
          required={true}
          emptyText={t('nameEmptyText')}
          invalidText={t('nameInvalidText')}
        />
        <InputManager
          id="phone"
          placeholder={t('inputPhone')}
          className="logicpro-contact-form-field"
          validate={validatePhone}
          required={true}
          emptyText={t('phoneEmptyText')}
          invalidText={t('phoneInvalidText')}
        />
        <InputManager
          id="email"
          placeholder={t('inputEmail')}
          className="logicpro-contact-form-field"
          invalidText={t('emailInvalidText')}
        />
        <InputManager
          id="interested_fields"
          type="textarea"
          placeholder="Enter list of interested courses for which syllabus is required"
          className="logicpro-contact-form-field-area"
          emptyText={'Cannot be empty'}
          invalidText={'Invalid text'}
        />
        <Button
          indicatorColor="white"
          className="logicpro-request-callback-submit-btn"
          loading={isLoading}
          type="submit"
          text="Submit"
        />
      </FormManager>
      {isAlertActive && (
        <Alert
          title={isSuccess ? t('alertSuccessTitle') : t('alertFailedTitle')}
          type={isSuccess ? 'success' : 'failed'}
        />
      )}
    </div>
  );
};

const mapStateToProps = (store, props) => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ requestCallback }, dispatch);
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RequestCallbackForm));



// WEBPACK FOOTER //
// ./src/Pages/SummerInternships/LogicPro/RequestCallbackForm.js